import CloseIcon from '@mui/icons-material/Close'
import SearchIcon from '@mui/icons-material/Search'

import FilterGridContainer from '@components/toolbar/FilterGridContainer'
import FilterGridItem from '@components/toolbar/FilterGridItem'
import { FilterSearch } from '@components/toolbar/FilterSearch'
import { FilterSelectGebied } from '@components/toolbar/FilterSelectGebied'
import { FilterSelectObject } from '@components/toolbar/FilterSelectObject'
import type { Gebied } from '@models/Gebied'

import { useLocalFilters } from '../../core/hooks/useLocalFilters'
import { StyledIconButton } from '../../theme/components/StyledIconButton'
import type { FilterOptionNumber } from '../types/FilterOptionNumber'
import type { ProjectmeldingenSearchFilters as Filters } from '../types/ProjectmeldingenSearch'

interface Props {
  onChange: (filters: Filters) => void
  filters: Filters
  initialFilters: Filters
  onRefresh: () => void
  onReset: () => void
  filterOptions: {
    projectmelding: {
      status: FilterOptionNumber[]
      tags: FilterOptionNumber[]
    }
    gebieden: Gebied[]
  }
}

export const ProjectmeldingenFilters = ({
  onChange,
  filters,
  initialFilters,
  onReset,
  onRefresh,
  filterOptions: {
    projectmelding: { status: statusOptions, tags: tagOptions },
    gebieden,
  },
}: Props) => {
  const { localFilters, handleFilterChange, handleZoeken, handleReset } =
    useLocalFilters<Filters>({
      filters,
      initialFilters,
      onChange,
      onRefresh,
      onReset,
    })

  const { statuscode, gebied, search, tags } = localFilters

  return (
    <FilterGridContainer>
      <FilterGridItem>
        <FilterSelectGebied
          options={gebieden}
          value={gebied}
          onFilterChange={handleFilterChange}
        />
      </FilterGridItem>

      <FilterGridItem>
        <FilterSelectObject
          multiple
          options={statusOptions}
          label="Status"
          filterKey="statuscode"
          value={statuscode}
          onFilterChange={handleFilterChange}
        />
      </FilterGridItem>

      <FilterGridItem>
        <FilterSelectObject
          multiple
          options={tagOptions}
          label="Planvorming onderwerpen"
          filterKey="tags"
          value={tags}
          onFilterChange={handleFilterChange}
        />
      </FilterGridItem>

      <FilterGridItem>
        <FilterSearch
          label="Zoeken"
          filterName="search"
          onFilterChange={handleFilterChange}
          value={search}
        />
      </FilterGridItem>

      <FilterGridItem
        minColumns="full"
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
        }}
      >
        <StyledIconButton
          icon={<CloseIcon />}
          title="Reset filters"
          onClick={handleReset}
        />
        <StyledIconButton
          icon={<SearchIcon />}
          title="Filters toepassen"
          onClick={handleZoeken}
        />
      </FilterGridItem>
    </FilterGridContainer>
  )
}
